import { useLoaderData } from 'react-router';

import Body from '../Body';
import Layout from './Layout';

function LayoutPage({ children, bodyClassName, bodyStyle, wide, ...other }: any) {
  const loaderData = useLoaderData();
  children = loaderData?.children || children;

  return (
    <Layout {...other}>
      <Body
        className={bodyClassName}
        style={{ paddingTop: 20, paddingBottom: 30, ...bodyStyle }}
        wide={wide}
      >
        {children}
      </Body>
    </Layout>
  );
}

export default LayoutPage;
